export function isStaging() {
	return import.meta.env.VITE_APP_ENV === 'staging'
}

export function isProduction() {
	return import.meta.env.VITE_APP_ENV === 'production'
}
